import * as yup from "yup";

const createCityValidator = yup
  .object({
    name: yup.string().required("Name is required"),
  })
  .required();

export default createCityValidator;
